import { graphql, useStaticQuery } from 'gatsby';

import {
  mapBlogToComponent,
  mapStoryToComponent,
  mapUseCasesToComponent,
} from '../components/blocks/CardGroupBlock/cardGroupBlockUtils';

// Card Types:
// useCases = 3 Use Case cards
// allUseCases = All Use Case cards 3 cards per row
// blogs = 3 most recent blog posts
// stories = 3 most recent stories
// twoHomeownerQuotes = 2 most recent homeowner's quotes

export const useDefaultCardData = ({ cardType }) => {
  const data = useStaticQuery(
    graphql`
      query defaultCardData {
        useCases: allWpPost(
          filter: { categories: { nodes: { elemMatch: { slug: { eq: "use-case" } } } } }
          sort: { fields: useCaseFields___useCaseOrder, order: ASC }
        ) {
          nodes {
            ...GetUseCaseCardFields
          }
        }

        blogs: allWpPost(filter: { categories: { nodes: { elemMatch: { slug: { eq: "blog" } } } } }, limit: 3) {
          nodes {
            ...GetAllBlogPosts
          }
        }

        stories: allWpPost(filter: { categories: { nodes: { elemMatch: { slug: { eq: "stories" } } } } }, limit: 3) {
          nodes {
            ...GetAllHomeownerStoryPosts
          }
        }
      }
    `,
  );

  switch (cardType) {
    case 'useCases':
      return data.useCases.nodes.slice(0, 3).map(mapUseCasesToComponent);
    case 'allUseCases':
      return data.useCases.nodes.map(mapUseCasesToComponent);
    case 'blogs':
      return data.blogs.nodes.map(mapBlogToComponent);
    case 'stories':
      return data.stories.nodes.map(mapStoryToComponent);
    case 'twoHomeownerQuotes':
      return data.stories.nodes.slice(0, 2);
    default:
      break;
  }
};

export const DEFAULT_INFO_CARDS = [
  {
    link: 'https://www.hometap.com/documents/what_homeowners_should_know_about_hometap.pdf',
    title: 'About Hometap',
    description: 'What your homeowner should know.',
    image: 'https://hometap.dream.press/wp-content/uploads/linkcard-ho-guide.jpg',
  },
  {
    link: 'https://www.hometap.com/why-hometap/compare-your-options/',
    title: 'How Hometap Compares',
    description: 'Learn how Hometap compares to home loans, HELOCs and home equity investments.',
    image: 'https://hometap.dream.press/wp-content/uploads/linkcard-compare.jpg',
  },
  {
    link: 'https://www.hometap.com/why-hometap/',
    title: 'Why Hometap',
    description: 'Find out why homeowners are choosing Hometap.',
    image: 'https://hometap.dream.press/wp-content/uploads/linkcard-why-hometap.jpg',
  },
];
